import { render, staticRenderFns } from "./chat-content-scroll.vue?vue&type=template&id=3c1b7ad6&scoped=true&"
import script from "./chat-content-scroll.vue?vue&type=script&lang=js&"
export * from "./chat-content-scroll.vue?vue&type=script&lang=js&"
import style0 from "./chat-content-scroll.vue?vue&type=style&index=0&id=3c1b7ad6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1b7ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1b7ad6')) {
      api.createRecord('3c1b7ad6', component.options)
    } else {
      api.reload('3c1b7ad6', component.options)
    }
    module.hot.accept("./chat-content-scroll.vue?vue&type=template&id=3c1b7ad6&scoped=true&", function () {
      api.rerender('3c1b7ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/chatChartSupervise/components/chat-content-scroll.vue"
export default component.exports